import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class FleetService {
  fleetRemarks = new BehaviorSubject([]);
  selectedFleet = new BehaviorSubject('');
  loading = new BehaviorSubject(false);

  constructor(
    private http: HttpClient,
    private message: NzMessageService,
  ) {}

  createFleet(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/fleet/create`, payload).subscribe({
        next: (response: any) => {
          this.message.create('success', `New Vehicle has been added!`);
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error);
        },
      });
    });
  }

  updateFleet(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put(`${SETTINGS.BASE_API}/fleet/update`, payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error);
        },
      });
    });
  }

  getPagedFleet(payload: any): Observable<any> {
    this.loading.next(true);
    return this.http.post(`${SETTINGS.BASE_API}/fleet/get-paged`, payload);
  }

  getFleetsAsOptions(payload: any): Promise<any> {
    const options: any = { timeZoneName: 'long' };
    const formatter = new Intl.DateTimeFormat([], options);
    payload.timezone = formatter.resolvedOptions().timeZone;
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/fleet/get-options`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  deleteFleet(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/fleet/soft-delete/${id}`)
        .subscribe({
          next: (response: any) => {
            this.message.create('success', `Vehicle has been deleted!`);
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getOneFleetById(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/fleet/get/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }

  // Vehicle Category request
  getAllVehicleCat(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/fleet/get-vehicle-cat`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }

  getOneVehicleCat(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/fleet/get-cat/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }
  getVehicleCatCode(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/fleet/get-cat-code/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }

  // Fleet remark APIs
  createFleetRemark(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/fleet/remark/create`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  updateFleetRemark(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/fleet/remark/update`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getFleetRemarksByFleet(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/fleet/remark/get-all/${id}`)
        .subscribe({
          next: (response: any) => {
            this.fleetRemarks.next(response);
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getAvailableFleet(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/fleet/get-available`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getAllBookingsByFleet(fleet: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/fleet/get-bookings/${fleet}`);
  }
}
